export default __webpack_public_path__ + "static/media/img-0230-netherlands-half-face.6ef6cba4.png";